import paginationFields, {
  registrationsPagination,
  cacheMerge
} from "./pagination_fields.js";

import { getTranslation, fetchField, fetchMultiple } from "./utils";

const fields = {
  role: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },

  profQualificationApprovalReason: {
    read(value, methods) {
      return (
        value ??
        fetchField(methods, { typename: "ProfQualificationApprovalReason" })
      );
    }
  },

  passportDocumentIssuingBody: {
    read(value, methods) {
      return (
        value ?? fetchField(methods, { typename: "HorseDocumentIssuingBody" })
      );
    }
  },
  breedingStudbook: {
    read(value, methods) {
      return value ?? fetchField(methods, { typename: "Studbook" });
    }
  },
  country: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },
  applicantCountry: {
    read(value, methods) {
      return value ?? fetchField(methods, { typename: "Country" });
    }
  },
  birthCountry: {
    read(value, methods) {
      return value ?? fetchField(methods, { typename: "Country" });
    }
  },

  addressCountry: {
    read(value, methods) {
      return value ?? fetchField(methods, { typename: "Country" });
    }
  },
  deliveryAddressCountry: {
    read(value, methods) {
      return value ?? fetchField(methods, { typename: "Country" });
    }
  },
  registryCountry: {
    read(value, methods) {
      return value ?? fetchField(methods, { typename: "Country" });
    }
  },
  representingCountry: {
    read(value, methods) {
      return value ?? fetchField(methods, { typename: "Country" });
    }
  },
  legalForm: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },
  discipline: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },
  breed: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },
  region: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },
  representingRegion: {
    read(value, methods) {
      return value ?? fetchField(methods, { typename: "Region" });
    }
  },
  personClubRegion: {
    read(value, methods) {
      return value ?? fetchField(methods, { typename: "Region" });
    }
  },
  profQualificationGroup: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },
  profQualification: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },
  licenceCategory: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },
  personLicenceCategory: {
    read(value, methods) {
      return value ?? fetchField(methods, { typename: "LicenceCategory" });
    }
  },

  cancelReason: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },

  eventcode: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },
  difficultyLevel: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },
  competitionRule: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },
  individualCompetitionRule: {
    read(value, methods) {
      return value ?? fetchField(methods, { typename: "CompetitionRule" });
    }
  },
  competitionLevel: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },
  highestCompetitionLevel: {
    read(value, methods) {
      return value ?? fetchField(methods, { typename: "CompetitionLevel" });
    }
  },
  section: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },

  chartRule: {
    read(value, methods) {
      return value ?? fetchField(methods, { customFieldName: "ChartRule" });
    }
  },

  qualificationGroup: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },

  qualification: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },

  organisationalFunction: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },
  organisationalTitle: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },

  disciplines: {
    read(v, methods) {
      if (v) return v;
      const ids = methods.readField("disciplineIds");
      if (!ids) return [];
      return fetchMultiple({ ids, typename: "Discipline" }, methods);
    }
  },

  hasResultsInDisciplines: {
    read(_, methods) {
      const disciplineIds =
        methods.readField("hasResultsInDisciplineIds") ?? [];
      return fetchMultiple(
        { ids: disciplineIds, typename: "Discipline" },
        methods
      );
    }
  },

  competitionLevels: {
    read(v, methods) {
      if (v) return v;
      const ids = methods.readField("competitionLevelIds");
      if (!ids) return [];
      return fetchMultiple({ ids, typename: "CompetitionLevel" }, methods);
    }
  },

  profQualifications: {
    read(v, methods) {
      if (v) return v;
      const ids = methods.readField("profQualificationIds");
      if (!ids) return [];
      return fetchMultiple({ ids, typename: "ProfQualification" }, methods);
    }
  },

  sections: {
    read(v, methods) {
      if (v) return v;
      const ids = methods.readField("sectionIds");
      if (!ids) return [];
      return fetchMultiple({ ids, typename: "Section" }, methods);
    }
  },

  certificateGroup: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  },
  certificateDefinition: {
    read(value, methods) {
      return value ?? fetchField(methods);
    }
  }
};

export default {
  possibleTypes: {},
  typePolicies: {
    Query: {
      fields: {
        ...paginationFields,
        surveyElements: {
          read(incoming = []) {
            return incoming;
          }
        }
      }
    },
    FederationConfiguration: {
      merge: true
    },
    Point: {
      fields: {
        chartRule: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "ChartRule" });
          }
        }
      }
    },
    Address: {
      fields: fields
    },
    Country: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        }
      }
    },
    CompetitionEntryRuleTemplate: {
      fields: {
        ...fields,
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        }
      }
    },
    PersonLicence: {
      fields: fields
    },
    HorseSportLicence: {
      fields: fields
    },
    ProfQualification: {
      fields: fields
    },
    ChartTableQuery: {
      fields: fields
    },
    QualificationGroup: {
      fields: fields
    },
    Qualification: {
      fields: fields
    },
    QualificationRule: {
      fields: fields
    },
    PersonRole: {
      fields: {
        ...fields,
        role: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Role" });
          }
        }
      }
    },
    ExtResApplicationCompetition: {
      fields: fields
    },
    SurveyRolePermissionset: {
      fields: fields
    },
    SanctionReason: {
      fields: fields
    },
    Survey: {
      fields: fields
    },
    Chart: {
      fields: fields
    },
    Organisation: {
      fields: fields
    },
    EventStaffFunctionDefinition: {
      fields: fields
    },
    EventStaffFunctionTeamTemplate: {
      fields: {
        ...fields,
        eventStaffFunctionDefinitions: {
          read(v, methods) {
            if (v) return v;
            const ids =
              methods.readField("eventStaffFunctionDefinitionIds") ?? [];
            return fetchMultiple(
              { ids: ids, typename: "EventStaffFunctionDefinition" },
              methods
            );
          }
        }
      }
    },
    EventStaffFunction: {
      fields: fields
    },
    Event: {
      fields: {
        ...fields,
        eventCategories: {
          read(v, methods) {
            if (v) return v;
            const ids = methods.readField("eventCategoryIds");
            if (!ids) return [];
            return fetchMultiple({ ids, typename: "EventCategory" }, methods);
          }
        },
        profQualifications: {
          read(v, methods) {
            if (v) return v;
            const ids = methods.readField("profQualificationIds");
            if (!ids) return [];
            return fetchMultiple(
              { ids, typename: "ProfQualification" },
              methods
            );
          }
        },
        cancelReason: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },
        country: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },

        region: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },

        discipline: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },

        registrations: registrationsPagination()
      }
    },
    Person: {
      fields: {
        ...fields,
        name: {
          read(value) {
            return value;
          }
        },
        mainDiscipline: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Discipline" });
          }
        },
        licenceCategory: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },
        personLicenceCategory: {
          read(value, methods) {
            return (
              value ?? fetchField(methods, { typename: "LicenceCategory" })
            );
          }
        },
        country: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Country" });
          }
        },
        activePersonHorses: {
          read(existing) {
            return existing;
          },
          keyArgs: false,
          merge: cacheMerge
        }
      }
    },
    ProfQualificationApplication: {
      fields: {
        ...fields,
        personProfQualification: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    PersonProfQualification: {
      fields: {
        ...fields,
        person: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    Horse: {
      fields: {
        ...fields,
        breedingStudbook: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Studbook" });
          }
        },
        color: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "HorseColor" });
          }
        },
        breed: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },
        birthCountry: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Country" });
          }
        },
        allowedFields: {
          read(value) {
            if (!value) return [];
            return value;
          }
        }
      }
    },
    Registration: {
      fields: {
        ...fields,
        athletes: {
          read(existing = []) {
            return existing;
          }
        },
        horses: {
          read(existing = []) {
            return existing;
          }
        },
        event: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    RegistrationPerson: {
      fields: fields
    },
    RegistrationHorse: {
      fields: fields
    },
    RegistrationEventProduct: {
      fields: {
        ...fields,
        eventProduct: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    Entry: {
      fields: {
        ...fields,
        feedbackMessages: {
          read(value) {
            if (!value) return [];
            return value;
          }
        },
        section: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },
        competition: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },
        registration: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    Result: {
      fields: {
        ...fields,
        competitionRule: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    Competition: {
      fields: {
        ...fields,
        event: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },
        difficultyLevel: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },
        competitionRule: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },
        eventcode: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },
        competitionLevel: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    CompetitionLevel: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        }
      }
    },
    EventProduct: {
      fields: {
        product: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },
        vatRate: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    EventSurvey: {
      fields: {
        survey: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    EventInfoField: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        description: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        eventInfoCategory: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    Sanction: {
      fields: {
        sanctionReasons: {
          read(value, { readField, toReference }) {
            if (value) return value;
            return (readField("sanctionReasonIds") ?? []).map(id => {
              return toReference({
                __typename: "SanctionReason",
                id
              });
            });
          }
        }
      }
    },
    PersonApplication: {
      fields: fields
    },
    InvoiceLine: {
      fields: {
        product: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },
        vatRate: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    Contact: {
      fields: {
        ...fields,
        addressCountry: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Country" });
          }
        },
        registryCountry: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Country" });
          }
        }
      }
    },
    HorseContact: {
      fields: {
        ...fields,
        addressCountry: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Country" });
          }
        }
      }
    },
    HorseForRegistration: {
      ...fields,
      addressCountry: {
        read(value, methods) {
          return value ?? fetchField(methods, { typename: "Country" });
        }
      }
    },
    HorseApplication: {
      fields: {
        ...fields,
        applicantRegistryCountry: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Country" });
          }
        },
        applicantCountry: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Country" });
          }
        },
        horseBirthCountry: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Country" });
          }
        },
        horseBreed: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Breed" });
          }
        },
        horseBreedingStudbook: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Studbook" });
          }
        },
        horsePassportDocumentIssuingBody: {
          read(value, methods) {
            return (
              value ??
              fetchField(methods, {
                typename: "HorseDocumentIssuingBody"
              })
            );
          }
        },
        horseAffiliatedWithRegion: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Region" });
          }
        },
        horseColor: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "HorseColor" });
          }
        }
      }
    },
    ExtResApplication: {
      fields: {
        ...fields,
        eventCountry: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Country" });
          }
        }
      }
    },
    Payable: {
      fields: {
        product: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    Product: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        description: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        addonProducts(v, methods) {
          if (v) return v;
          const ids = methods.readField("addonProductIds");
          if (!ids) return [];
          return fetchMultiple({ ids, typename: "Product" }, methods);
        },
        deductibleProducts(v, methods) {
          if (v) return v;
          const ids = methods.readField("deductibleProductIds");
          if (!ids) return [];
          return fetchMultiple({ ids, typename: "Product" }, methods);
        },
        purchaseActions(_, { readField, toReference }) {
          if (_) return _;
          const ids = readField("purchaseActionIds");
          if (!ids) return [];
          return ids.map(id =>
            toReference({
              __typename: "Action",
              id
            })
          );
        }
      }
    },
    Role: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        profQualifications: {
          read(_, { readField, toReference }) {
            if (_) return _;
            const ids = readField("profQualificationIds");
            if (!ids) return null;
            return ids.map(id =>
              toReference({
                __typename: "ProfQualfication",
                id
              })
            );
          }
        }
      }
    },
    SanctionDefinition: {
      fields: {
        ...fields,
        sanctionReasons: {
          read(v, { readField, toReference }) {
            if (v) return v;
            const ids = readField("sanctionReasonIds");
            if (!ids) return [];
            return ids.map(id =>
              toReference({
                __typename: "SanctionReason",
                id
              })
            );
          }
        }
      }
    },
    ChartRule: {
      fields: {
        chart: {
          read(_, { readField, toReference }) {
            if (_) return _;
            const id = readField("chartId");
            if (!id) return null;
            return toReference({
              __typename: "Chart",
              id
            });
          }
        }
      }
    },
    Cup: {
      fields: {
        discipline: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    CupSeason: {
      fields: {
        cup: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    Rule: {},
    RuleConditions: {},
    Section: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        shortName: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        description: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        discipline: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },
        difficultyLevel: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    CompetitionRule: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        description: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        discipline: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },
        difficultyLevel: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    DifficultyLevel: {
      fields: {
        discipline: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    Eventcode: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        discipline: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },
        difficultyLevel: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    ExamGroup: {
      fields: {
        ...fields,
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        discipline: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    ExamDefinition: {
      fields: {
        ...fields,
        examGroup: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    PersonExam: {
      fields: {
        examDefinition: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    PersonOrganisationFunction: {
      fields
    },
    CertificateDefinition: {
      fields
    },
    PersonCertificate: {
      fields
    },
    PersonInsurance: {
      fields: {
        ...fields,
        insuranceCategory: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    OrganisationalTitle: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        }
      }
    },
    OrganisationalFunction: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        }
      }
    },
    ProfQualificationGroup: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        }
      }
    },
    HorseColor: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        }
      }
    },
    Breed: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        }
      }
    },
    CertificateGroup: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        }
      }
    },
    CancelReason: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        }
      }
    },
    LicenceCategory: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        }
      }
    },
    ReportDefinition: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        description: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        roles: {
          read(v, { readField, toReference }) {
            if (v) return v;
            const ids = readField("roleIds");
            if (!ids) return [];
            return ids.map(id =>
              toReference({
                __typename: "Role",
                id
              })
            );
          }
        }
      }
    },
    Report: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        description: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        }
      }
    },
    EventProductCategory: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        description: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        }
      }
    },
    EventInfoCategory: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        description: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        template: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        }
      }
    },
    Region: {
      fields: {
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        nameShort: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        parentRegion: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Region" });
          }
        }
      }
    },
    CompetingDifficultyLevelGroup: {
      fields: {
        ...fields,
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        }
      }
    },
    CompetingDifficultyLevelDefinition: {
      fields: {
        ...fields,
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        competingDifficultyLevelGroup: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    },
    CompetingDifficultyLevelRule: {
      fields: {
        ...fields,
        name: {
          read(value, helpers) {
            return getTranslation(value, helpers);
          }
        },
        competingDifficultyLevelDefinition: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        },
        basedOnQualification: {
          read(value, methods) {
            return value ?? fetchField(methods, { typename: "Qualification" });
          }
        }
      }
    },
    CompetingDifficultyLevel: {
      fields: {
        ...fields,
        competingDifficultyLevelDefinition: {
          read(value, methods) {
            return value ?? fetchField(methods);
          }
        }
      }
    }
  }
};
